import { FC } from "react";
import { Controller } from "react-hook-form";
import { GroupBase, OptionsOrGroups } from "react-select";

import HubInputField from "src/components/inputType";

import { US_STATES } from "src/constants";
import { SiteOfCareCompProps } from "./types";



const SiteOfCareComp: FC<SiteOfCareCompProps> = ({ control }): JSX.Element => {
  return (
    <>
      <div className="row mt-4">
        <div className="col-lg-6">
          <Controller
            name="shipments_attributes.0.ship_to_street"
            control={control}
            defaultValue=""
            render={({field, fieldState: {error}}) => (
              <div className={"row"}>
                <label className={"form-label col-lg-4 col-md-4 col-12"}>Street</label>
                <div className={"col-lg-8 col-md-8 col-12"}>
                  <HubInputField
                    isRowBased={false}
                    isRequired={false}
                    inputId="shipments_attributes.0.ship_to_street"
                    inputPlaceholder="Street"
                    field={field}
                    error={error}
                  />
                </div>
              </div>
            )}
          />
        </div>

        <div className="col-lg-6">
          <Controller
            name="shipments_attributes.0.ship_to_suite"
            control={control}
            defaultValue=""
            render={({field, fieldState: {error}}) => (
              <div className={"row"}>
                <label className={"form-label col-lg-4 col-md-4 col-12"}>Suite</label>
                <div className={"col-lg-8 col-md-8 col-12"}>
                  <HubInputField
                    isRowBased={true}
                    isRequired={false}
                    inputId="shipments_attributes.0.ship_to_suite"
                    inputPlaceholder="Suite"
                    field={field}
                    error={error}
                  />
                </div>
              </div>
            )}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6">
          <Controller
            name="shipments_attributes.0.ship_to_city"
            control={control}
            defaultValue=""
            render={({field, fieldState: {error}}) => (
              <div className={"row"}>
                <label className={"form-label col-lg-4 col-md-4 col-12"}>City</label>
                <div className={"col-lg-8 col-md-8 col-12"}>
                  <HubInputField
                    isRowBased={true}
                    isRequired={false}
                    inputId="shipments_attributes.0.ship_to_city"
                    inputPlaceholder="City"
                    field={field}
                    error={error}
                  />
                </div>
              </div>
            )}
          />
        </div>

        <div className="col-lg-6">
          <Controller
            name="shipments_attributes.0.ship_to_state"
            control={control}
            defaultValue=""
            render={({field, fieldState: {error}}) => (
              <div className={"row"}>
                <label className={"form-label col-lg-4 col-md-4 col-12"}>State</label>
                <div className={"col-lg-8 col-md-8 col-12"}>
                  <HubInputField
                    isRowBased={true}
                    isRequired={false}
                    inputId="shipments_attributes.0.ship_to_state"
                    inputPlaceholder="Select State..."
                    field={field}
                    error={error}
                    isDropdown={true}
                    isSearchable={true}
                                      isTypeAhead={true}

                    dropdownData={US_STATES as unknown as OptionsOrGroups<string, GroupBase<string>>}
                  />
                </div>
              </div>
            )}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6">
          <Controller
            name="shipments_attributes.0.ship_to_zip"
            control={control}
            defaultValue=""
            render={({field, fieldState: {error}}) => (
              <div className={"row"}>
                <label className={"form-label col-lg-4 col-md-4 col-12"}>Zip</label>
                <div className={"col-lg-8 col-md-8 col-12"}>
                  <HubInputField
                    isRowBased={true}
                    isRequired={false}
                    inputId="shipments_attributes.0.ship_to_zip"
                    inputPlaceholder="Zip"
                    field={field}
                    error={error}
                  />
                </div>
              </div>
            )}
          />
        </div>
      </div>
    </>
  );
};

export default SiteOfCareComp;
